/**
 * SkillDelivery Platform
 *
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This source code is the exclusive property of SKD RATWANI Technology &
 * Software Solutions Pvt Ltd, operating as "SkillDelivery". Unauthorized
 * copying, modification, distribution, or use of this software, via any
 * medium, is strictly prohibited without express written permission.
 *
 * For licensing inquiries: legal@skilldelivery.co.in
 *
 * Registered Office: Sitapur, Uttar Pradesh, India - 261001
 * Jurisdiction: Noida, Uttar Pradesh, India - 201301
 */

import React from 'react';
import './Footer.css';

const Footer = ({ hasSidebar = true }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={hasSidebar ? "skilldelivery-footer" : "skilldelivery-footer-full"}>
      <div className="footer-content">
        <div className="footer-brand">
          <span className="brand-name">SkillDelivery</span>
          <span className="copyright">© {currentYear}</span>
        </div>
        <div className="footer-links">
          <a
            href="https://skilldelivery.co.in/terms.html"
            target="_blank"
            rel="noopener noreferrer"
          >Terms</a>
          <span aria-hidden="true"> · </span>
          <a
            href="https://skilldelivery.co.in/terms.html#guardrails"
            target="_blank"
            rel="noopener noreferrer"
          >Use Policy</a>
          <span aria-hidden="true"> · </span>
          <a
            href="https://skilldelivery.co.in/getting-started.html"
            target="_blank"
            rel="noopener noreferrer"
          >Getting Started</a>
        </div>
        <div className="footer-company">
          A platform by <strong>SKD RATWANI Technology & Software Solutions Pvt Ltd</strong>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
